<div class="header">
  <h3>
    <ng-container *ngIf="storeId; else plainTitle">
      <a [routerLink]="['/store', storeId, 'catalog']">{{ 'store.taxes.catalogItems' | translate }}</a>
      &nbsp;>&nbsp;{{ 'form.button.search' | translate }}
    </ng-container>
    <ng-template #plainTitle>{{ 'catalog.searchModal.title' | translate }}</ng-template>
  </h3>
  <div class="header-actions">
    <div class="search-container">
      <form [formGroup]="form" class="input-container">
        <mat-form-field class="search">
          <mat-label>{{ 'catalog.searchModal.fields.search' | translate }}</mat-label>
          <input formControlName="searchInput" data-qa-label="SearchInput" matInput (keydown.enter)="handleSearch()"/>
        </mat-form-field>

        <mat-form-field class="search">
          <mat-label>{{ 'catalog.searchModal.fields.plu' | translate }}</mat-label>
          <input formControlName="plu" data-qa-label="PluInput" matInput (keydown.enter)="handleSearch()"/>
        </mat-form-field>

        <mat-form-field class="type">
          <mat-label>{{ 'catalog.searchModal.fields.type' | translate }}</mat-label>
          <mat-select matInput data-qa-label="Type" formControlName="itemType">
            <mat-option *ngFor="let catalogType of catalogTypes" [value]="catalogType">
              {{ catalogType.label  | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>

      <div class="search-actions">
        <txp-button [style]="buttonStyle.SECONDARY"
                    data-qa-label="ResetButton"
                    [disabled]="isLoading"
                    (click)="handleReset()">{{ 'catalog.searchModal.resetFiltersBtn' | translate }}</txp-button>
        <txp-button [style]="buttonStyle.PRIMARY"
                    [loading]="isLoading"
                    data-qa-label="SearchFilterButton"
                    [disabled]="!searchEnabled()"
                    (click)="handleSearch()">{{ 'catalog.searchModal.searchFilterBtn' | translate }}</txp-button>
      </div>
    </div>
  </div>
</div>

<div class="messages">
  <txp-message [type]="messageType.DANGER" data-qa-label="ErrorMsg" *ngIf="showError">
    {{ 'catalog.searchModal.errorMsg' | translate }}
  </txp-message>
  </div>

<div class="table-content">
  <div class="catalog-grid">
    <div class="catalog-table-container">
      <table mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDirection="asc" matSortDisableClear multiTemplateDataRows>

        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? masterToggle() : null"
                          [checked]="selection.hasValue() && isAllSelected()"
                          [indeterminate]="selection.hasValue() && !isAllSelected()"
                          data-qa-label="MasterToggleCheckBox"
                          [attr.aria-label]="'Select all items'">
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? selection.toggle(row) : null"
                          [checked]="selection.isSelected(row)"
                          data-qa-label="CatalogItemCheckBox">
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'catalog.searchModal.name' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let catalogItem">
            <a class="item-link" (click)="goToItem(catalogItem)" [attr.title]="catalogItem.name" data-qa-label="ItemLink" href="javascript:void(0);">
              {{ catalogItem.name }}
            </a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'catalog.searchModal.type' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let catalogItem"> {{ catalogItem.itemType }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="plu">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'catalog.searchModal.plu' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let catalogItem"> {{ catalogItem.plu }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'catalog.searchModal.actions' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let catalogItem">
            <txp-button
              *ngIf="!isExpanded(catalogItem) || isLoadingParents(catalogItem)"
              [style]="buttonStyle.SECONDARY"
              [size]="buttonSize.EXTRA_SMALL"
              [loading]="isLoadingParents(catalogItem)"
              [disabled]="isLoadingParents(catalogItem)"
              (click)="toggleParentExpansion(catalogItem)"
              data-qa-label="ViewParentsButton">
              {{ 'catalog.searchModal.viewParents' | translate }}
            </txp-button>
            <txp-button
              *ngIf="isExpanded(catalogItem) && !isLoadingParents(catalogItem)"
              [style]="buttonStyle.SECONDARY"
              [size]="buttonSize.EXTRA_SMALL"
              (click)="toggleParentExpansion(catalogItem)"
              data-qa-label="CloseParentsButton">
              {{ 'catalog.searchModal.closeParents' | translate }}
            </txp-button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let catalogItem">
            <ng-container *ngIf="isExpanded(catalogItem)">
              <table mat-table [dataSource]="getParentItems(catalogItem)" class="parent-table">
                <ng-container matColumnDef="select">
                  <td mat-cell *matCellDef="let parentItem">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  (change)="$event ? toggleParentSelection(parentItem) : null"
                                  [checked]="isParentSelected(parentItem)"
                                  data-qa-label="ParentItemCheckBox">
                    </mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <td mat-cell *matCellDef="let parentItem" class="parent-name">
                    <a class="item-link"
                       (click)="goToParentItem(parentItem)"
                       [attr.title]="parentItem.title || parentItem.name"
                       data-qa-label="ParentItemLink"
                       href="javascript:void(0);">
                      {{ parentItem.title || parentItem.name }}
                    </a>
                  </td>
                </ng-container>
                <ng-container matColumnDef="type">
                  <td mat-cell *matCellDef="let parentItem">{{ parentItem.entityType }}</td>
                </ng-container>
                <ng-container matColumnDef="plu">
                  <td mat-cell *matCellDef="let parentItem">{{ parentItem.sku?.[0]}}</td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <td mat-cell *matCellDef="let parentItem"></td>
                </ng-container>
                <tr mat-row *matRowDef="let parentItem; columns: ['select', 'name', 'type', 'plu', 'actions']" class="parent-row"></tr>
              </table>
              <div class="no-parents-message" *ngIf="getParentItems(catalogItem).length === 0 && !isLoadingParents(catalogItem)">
                <span>{{ 'catalog.searchModal.noParentsFound' | translate }}</span>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="empty">
          <mat-footer-cell *matFooterCellDef colspan="100">
            <div [hidden]="!searchDone || dataSource.data.length">
              <mat-label>No matching Catalog Items</mat-label>
            </div>
          </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayColumns" [class.isExpanded]="isExpanded(row)"></mat-row>
        <!-- Expanded Detail row definition -->
        <mat-row *matRowDef="let row; columns: ['expandedDetail']" [hidden]="!isExpanded(row)" class="expanded-row"></mat-row>

        <mat-footer-row *matFooterRowDef="['empty']; sticky: true" [hidden]="!searchDone || dataSource.data.length"></mat-footer-row>
      </table>

    </div>
  </div>
</div>

<div class="actions" [hidden]="
  isLoading || (
    (!selection?.selected?.length) && (selectedParents.size === 0)
  )
">
  <txp-button data-qa-label="UpdateAvailabilityButton" [style]="buttonStyle.PRIMARY" (click)="openUpdateAvailabilityDialog()">
      {{ 'catalog.searchModal.updateAvailabilityBtn' | translate }}
  </txp-button>
</div>


